/* eslint-disable no-underscore-dangle */
/* eslint-disable spaced-comment */
/*
Item: Reference data display and edit form
Name: ReferenceData
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Panel } from 'primereact/components/panel/Panel';
// import { Link } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import MessageService from '../service/MessageService';
import { MultiLanguage } from '../utils/MultiLanguage';
import JsonHelper from '../utils/statisticsUtils';
import { DropdownLabeled } from '../components/DropdownLabeled';
import {
  hasPermission, actions, returnUserRights,
} from '../utils/roleUtils';
import '../styles/referenceData.css';
// import { configMyPouchDb, configPouchDb } from '../utils/configUtils';

const info = [
  {
    character: '*',
    description: 'Entspricht einer beliebigen Anzahl von Zeichen. Sie können das Sternchen (*) überall in einer Zeichenkette verwenden.',
    example: 'M*er findet Müller, Miller, Maler und Meister, aber nicht Motor oder Meyr',
  },
  {
    character: '?',
    description: 'Entspricht einem einzelnen Zeichen an einer bestimmten Stelle.',
    example: 'B?ll findet Ball, Bell und Bill',
  },
];

PouchDB.plugin(PouchDBFind);

const selectionList = [
  { name: 'Name', value: 'Fachschlüssel' },
  { name: 'Beschreibung', value: 'Kurztext' },
];

const rowsPerPage = 30;

export default class ReferenceData extends Component {
  constructor() {
    super();
    this.criteriaOptions = [
      { label: 'Fachschlüssel', value: 'KEY' },
      { label: 'Kurztext', value: 'SHORTTEXT' },
    ];
    this.sortingOptions = [
      { label: 'aufsteigend', value: 'ASCENDING' },
      { label: 'absteigend', value: 'DECENDING' },
    ];
    this.state = {
      // state for search bar
      searchCriterion: { name: 'Name', value: 'Fachschlüssel' },
      searchText: '',
      // state for sorting
      sortCriterion: 'Name',
      sortDirection: 'ASC',
      sortingSelection: {
        Name: 'ASC',
        Beschreibung: '',
        Klassifikationsschlüssel: '',
      },
      // all users Data to show the table
      pageData: null,
      // more
      deleteList: [],
      globalFilter: null,
      globalFilter0: null,
      globalFilter1: null,
      globalFilter2: null,
      valueName: '',
      valueDescription: '',
      valueLongtext: '',
      editTabNumber: 0,
      // showreload: false,
      // inMemoryDb: true,
      tabsObject: [],
      tabsEntrys: [],
      visible: false,
      editVisible: false,
      // statisticsList: '',
      shortLanguage: 'de',
      dsbData: undefined,
      //dsbDataRaw: undefined,
      characteristicData: undefined,
      expressionData: undefined,
      //characteristicDataRaw: undefined,
      //expressionDataRaw: undefined,
      activeIndexTab: 0,
      // maxRowsPerPage: 10,
      visibleDelete: false,
      entryProperties: [
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
      ],
      tableData: {
        refValues: {
          first: 0,
          last: 0,
          totalRecords: 0,
        },
      },
    };
    this.messageService = new MessageService();
    this.onPage = this.onPage.bind(this);
    this.multiLanguage = new MultiLanguage();
    const MY_POUCH_DB = window.MY_CACHE_NAME;
    // const POUCH_DB = window.CACHE_DB;
    this.db = new PouchDB(MY_POUCH_DB); //local
    // this.dbOnServer = new PouchDB(POUCH_DB); //local
  }

  //onLoad read current data
  componentDidMount = async () => {
    await this.loadDeleteList(); // nur für DSBs TODO
    // const countServer = await this.pouchDatadatabaseExists(this.dbOnServer);
    const count = await this.pouchDatadatabaseExists(this.db);
    if (count > 0) {
      this.setState({ visible: true });
      let nodes = null;
      nodes = await this.getFromPouch(this.db, 138); //DSB
      const dsbData = this.mapNodes(nodes);
      nodes = await this.getFromPouch(this.db, 3); //Merkmale
      const characteristicData = this.mapNodes(nodes);
      //nodes = await this.getFromPouch(this.db, 6); //Ausprägungen
      //const expressionData = this.mapNodes(nodes);
      this.loadDataPage();
      this.setState({
        dsbData,
        characteristicData,
        expressionData: {},
        visible: false,
      });
    } else {
      let tmp;
      tmp = await this.loadStatisticList('RECORD_STRUCTURE', 'recordstructure', 138, undefined, undefined, 100);
      if (tmp !== '') {
        tmp = await this.loadStatisticList('VARIABLE', 'variable', 3, undefined, undefined, 100); //Merkmal
      }
      if (tmp !== '') {
        //this.loadDataPage(null, 'TOP', null, rowsPerPage);
      }
    }
  };

  handleDelete(rowData, tabNumber) {
    this.setState({
      visibleDelete: true,
      selectedDelete: rowData,
      tabNumberDelete: tabNumber,
    });
  }

  handleNo() {
    this.setState({ visibleDelete: false, selectedDelete: '' });
  }

  async handleYesAgain() {
    const {
      selectedDelete,
      selectedDeleteAgain,
      linkAgain,
      objectAgain,
    } = this.state;
    const deleteOnly = (objectAgain !== 138);
    const selectedDeleteId = selectedDeleteAgain;
    let { textMessage } = this.state;
    textMessage = await this.messageService.postDependencyDelete(objectAgain,
      linkAgain, undefined, textMessage, undefined, deleteOnly);
    let doPouchDelete = false;
    if (textMessage[1] !== 'error') {
      this.setState({ visibleDeleteAgain: false, selectedDelete: '' });
      doPouchDelete = true;
    } else {
      const tmp = JsonHelper.deepCopy(selectedDelete);
      this.growl.show({ life: 12000, severity: textMessage[1], summary: 'Fehler beim Löschen', detail: textMessage[0] });
      this.setState({ visibleDelete: false, visibleDeleteAgain: false, selectedDelete: tmp });
    }
    // doPouchDelete = true;
    //PouchDB
    if (doPouchDelete) {
      const { db } = this;
      let noError = false;
      let theDoc = '';
      //Reading the contents of a Document
      await db.get(selectedDeleteId, (err, doc) => {
        if (err) {
          // eslint-disable-next-line no-console
          return console.log('Error in handleYesAgain', err);
        }
        noError = true;
        theDoc = doc;
      });
      await db.remove(selectedDeleteId, theDoc._rev, (err) => {
        if (err) {
          noError = false;
          // eslint-disable-next-line no-console
          console.log('Document delete usuccessful');
        } else {
          // eslint-disable-next-line no-console
          console.log('Document deleted successfully');
          noError = true;
        }
      });
      if (noError) {
        this.growl.show({ severity: 'success', summary: 'Löschen', detail: 'Daten wurde gelöscht' });
      } else {
        this.growl.show({ severity: 'error', summary: 'Fehler', detail: 'Daten konnte nicht gelöscht werden' });
      }
      this.setState({ visibleDelete: false, selectedDelete: '' });
      const { dsbData } = this.state;
      const tmp = JsonHelper.deepCopy(dsbData);
      // eslint-disable-next-line
      const removeItem = (items, i) => items.slice(0, i - 1).concat(items.slice(i, items.length))
      let res = [];
      for (let i = 0; i < tmp.length; i += 1) {
        if (selectedDeleteId !== tmp[i]._id) {
          res = res.concat(tmp[i]);
        }
      }
      this.setState({ visibleDeleteAgain: false });
      this.setState({ dsbData: res });
    }
  }

  async handleYes() {
    // const preparedEntries = '';
    const { selectedDelete, deleteList, tabNumberDelete } = this.state;
    const { name, id } = selectedDelete;
    // bei allen außer DSB:
    // die Eigenschaften des selectedDelete müssen geladen werden
    //Merkmal: id, 3, variable
    let object = 3;
    let link = 'variable';
    if (tabNumberDelete === 2) {
      //Ausprägung: id, 6, value
      object = 6;
      link = 'value';
    } else if (tabNumberDelete > 2) {
      //Ausprägung-Zuordnung: id, 112, valueassociation ///
      object = 112;
      link = 'valueassociation';
    } else if (tabNumberDelete === 0) {
      object = 138; // DSB
      link = 'recordstructure';
    }
    const linkAgain = link;
    const objectAgain = object;
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, object, link, true,
    );
    if (elementsData[0]) {
      this.growl.show({ severity: 'success', summary: 'Eigenschaften', detail: `Eigenschaften für ${name} (${id}) wurden geladen.` });
      if (elementsData[1] && elementsData[1] === 'error') {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      } else {
        // dann hat man den passenden Eintrag für preparedEntry
        const selectedDeleteId = selectedDelete._id;
        this.setState({ selectedDeleteAgain: selectedDeleteId });
        const entries = deleteList;
        let preparedEntry = '';
        if (tabNumberDelete === 0) {
          for (let i = 0; i < entries.length; i += 1) {
            if (entries[i].id === id) {
              preparedEntry = entries[i];
            }
          }
        }
        if (tabNumberDelete !== 0) {
          // get preparedEntry
          const elementsData = await this.messageService.postRecordStructureProperties(
            id, object, link, true,
          );
          preparedEntry = elementsData[0];
          // do delete
          const textMessage = await this.messageService.postDependencyDelete(
            id, link, preparedEntry, undefined, object, true,
          );
          let doPouchDelete = false;
          if (textMessage[1] !== 'error') {
            this.setState({ visibleDelete: false, selectedDelete: '' });
            doPouchDelete = true;
          } else if (textMessage[3] === 112) {
            this.setState({ visibleDelete: false, selectedDelete: '' });
            this.growl.show({
              life: 10000,
              severity: textMessage[1],
              summary: 'Fehler',
              detail: textMessage[0],
            });
          } else {
            const tmp = JsonHelper.deepCopy(selectedDelete);
            const visibleDeleteAgain = true;
            this.setState({
              visibleDelete: false,
              visibleDeleteAgain,
              selectedDelete: tmp,
              linkAgain: link,
              objectAgain: object,
              textMessage: textMessage[2],
            });
          }
          return;
        }
      }
    } else {
      this.growl.show({ severity: 'info', summary: 'Eigenschaften', detail: `Es konnte keine Eigenschaften für ${name} (${id}) geladen werden.` });
    }
    const textMessage = await this.messageService.postDependencyDelete('134', 'recordstructure', preparedEntry);
    let doPouchDelete = false;
    if (textMessage[1] !== 'error') {
      this.setState({ visibleDelete: false, selectedDelete: '' });
      doPouchDelete = true;
    } else if(textMessage[3] === 10310) {
      const tmp = JsonHelper.deepCopy(selectedDelete);
      this.setState({
        visibleDelete: false,
        visibleDeleteAgain: true,
        selectedDelete: tmp,
        textMessage: textMessage[2],
      });
    } else {
      this.setState({ visibleDelete: false, selectedDelete: '' });
      this.growl.show({
        life: 10000,
        severity: textMessage[1],
        summary: 'Fehler',
        detail: textMessage[0],
      });
    }

    //PouchDB
    if (doPouchDelete) {
      const { db } = this;
      let noError = false;
      let theDoc = '';
      //Reading the contents of a Document
      await db.get(selectedDeleteId, (err, doc) => {
        if (err) {
          // eslint-disable-next-line no-console
          return console.log('Error in doPouchDelete', err);
        }
        noError = true;
        theDoc = doc;
      });
      await db.remove(selectedDeleteId, theDoc._rev, (err) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.log('Document delete unsuccessful');
          noError = false;
        } else {
          // eslint-disable-next-line no-console
          console.log('Document deleted successfully');
          noError = true;
        }
      });
      if (noError) {
        this.growl.show({ severity: 'success', summary: 'Löschen', detail: 'Daten wurden gelöscht' });
      } else {
        this.growl.show({ severity: 'error', summary: 'Fehler', detail: 'Daten konnte nicht gelöscht werden' });
      }
      this.setState({ visibleDelete: false, selectedDelete: '' });
      const { dsbData } = this.state;
      const tmp = JsonHelper.deepCopy(dsbData);
      // eslint-disable-next-line
      const removeItem = (items, i) => items.slice(0, i - 1).concat(items.slice(i, items.length))
      let res = [];
      for (let i = 0; i < tmp.length; i += 1) {
        if (selectedDeleteId !== tmp[i]._id) {
          res = res.concat(tmp[i]);
        }
      }
      this.setState({ dsbData: res });
    }
  }

  async onPage(event, tableName) {
    this.setState({ loading: true });
    let {
      page,
      rows,
      pageCount,
    } = event;
    const {
      searchCriterion,
      searchText,
    } = this.state;
    if (!page) page = 0;
    const { tableData } = this.state;
    const first = parseInt(event.first, 10);
    // const result = '';
    const direction = 'TOP';
    const entries = null;
    const maxRowsPerPage = rows || 10; // default 10
    const scrolling = false;
    // const searchText = result;
    const sortDirection = 'ASC';
    const type = 'value';
    const objtype = 'VALUE';
    const object = 6;
    // const name = 'Fachschlüssel';
    const sortCriterion = 'Fachschlüssel';
    if (searchText && searchText !== '') page = 0;
    const obj = {
      exactSearch: true,
      readingDirection: direction,
      entries,
      maxRowsPerPage,
      scrolling,
      sortCriterion,
      sortDirection,
      searchCriterion: searchCriterion.value,
      searchText,
      objtype,
      object,
      page: page + 1,
      type,
    };
    console.log('LENGTH#0', obj)
    const pageData = await this.messageService.postPageDirectory(obj);
    if (!pageData[1]) {
      const jobs = pageData.entrys;
      const { validPages, potentialSelectionEntrySize } = pageData.viewSpecification;
      tableData[tableName].validPages = validPages;
      tableData[tableName].rows = maxRowsPerPage;
      tableData[tableName].totalRecords = potentialSelectionEntrySize;
      tableData[tableName].page = page;
      tableData[tableName].first = first;
      console.log('LENGTH#1', jobs.length - 1);
      tableData[tableName].last = first + jobs.length - 1;
      tableData[tableName].pageCount = pageCount;
      const data = jobs.map((item) => {
        const createdTime = item.createdDatabaseTime;
        const createdDateOnly = createdTime.split(' ')[0];
        const createdTimeOnly = createdTime.split(' ')[1];
        const classificationKey = item.classificationKey;
        const description = this.multiLanguage.returnLanguage(item.shortDescription, 'de');
        return {
          createdTime,
          createdDateOnly,
          createdTimeOnly,
          id: item.id,
          name: item.name,
          user: item.ownerInfo.user,
          classificationKey,
          description,
          item,
        };
      }, this);
      tableData[tableName].data = data;
    } else {
      this.growl.show({ severity: pageData[1], summary: 'Daten', detail: pageData[0] });
      searchText = '';
    }
    this.setState({
      searchText,
      loading: false,
      tableData,
    });
  }

  onHide(visibleString) {
    this.setState({ [visibleString]: false, selectedDelete: '' });
  }

  getFromPouch = async (db, s) => {
    const nodes = db.createIndex({
      index: {
        fields: ['docType'],
      },
    }).then(() => db.find({
      selector: {
        docType: { $eq: s },
      },
    }));
    return nodes;
  }

  returnLongtext = (el) => {
    let ret;
    if (el.longtext) {
      ret = el.longtext.langText[0].text;
    }
    return ret;
  }

  pouchDatadatabaseExists = async (db) => {
    const count = await db.info().then((result) => result.doc_count);
    return count;
  }

  handleSave = async () => { // do save properties triggered by button
    this.setState({ editVisible: false });
    const { editTabNumber } = this.state;
    const tabNumber = editTabNumber;
    let object = 3;
    let link = 'variable';
    const type = 'SUBJECT_CLASSIFYING';
    if (tabNumber === 2) {
      //Ausprägung: id, 6, value
      object = 6;
      link = 'value';
    } else if (tabNumber > 2) {
      //Ausprägung-Zuordnung: id, 112, valueassociation
      object = 112;
      link = 'valueassociation';
    } else if (tabNumber === 0) {
      //Ausprägung-Zuordnung: id, 138, recordstructure
      object = 138;
      link = 'recordstructure';
    }
    const {
      valueName,
      valueDescription,
      valueLongtext,
      tabsEntrys,
      entryProperties,
      dsbData,
      characteristicData,
      expressionData,
      tabsObject,
    } = this.state;
    const name = valueName;
    const text = valueDescription;
    const longtext = valueLongtext;
    const tabsEntrysTab = tabsEntrys[tabNumber];
    const tmp = [...entryProperties];
    tmp[tabNumber].shortdescription = text;
    this.setState({ entryProperties: tmp });
    await this.messageService.postPropertiesEdit(
      object, link, type, name, text, longtext, tabsEntrysTab,
    );
    let tmp2 = [];
    if (tabNumber === 0) {
      tmp2 = [...dsbData];
    } else if (tabNumber === 1) {
      tmp2 = [...characteristicData];
    } else {
      tmp2 = [...tabsObject];
    }
    let updatePouch = false;
    let pouchId = '';
    //tmp2[i].longtext = longtext;
    for (let i = 0; i < tmp2.length; i += 1) {
      if ((tabNumber < 2)) {
        if (name === tmp2[i].name) {
          //update frontend
          tmp2[i].name = name;
          tmp2[i].text = text;
          updatePouch = true;
          pouchId = tmp2[i]._id;
        }
      } else if (name === tmp2[tabNumber - 3].tabTable[i].name) {
        //tmp2[tabNumber - 3].tabTable[i].name = name;
        tmp2[tabNumber - 3].tabTable[i].langText = text;
        updatePouch = false;
        pouchId = tmp2[tabNumber - 3].tabTable[i]._id;
      }
      if (updatePouch) {
        updatePouch = false;
      }
    }
    if (tabNumber === 0) {
      this.setState({ characteristicData: tmp2 });
    } else if (tabNumber === 1) {
      this.setState({ expressionData: tmp2 });
    } else {
      this.setState({ tabsObject: tmp2 });
    }
    this.growl.show({ severity: 'success', summary: 'Speichern', detail: 'Eigenschaften für wurden gespeichert.' });
  }

  mapNodes = (nodes) => {
    // mapNodes(nodes) {
    const ret = [];
    for (let i = 0; i < nodes.docs.length; i += 1) {
      const entry = nodes.docs[i];
      const {
        _id, text, name, id, valueCount, classificationKey,
      } = entry;
      const item = {
        _id,
        text,
        name,
        id,
        valueCount,
        classificationKey,
      };
      ret.push(item);
    }
    return ret;
  }

  async loadDeleteList() {
    this.setState({ visible: true });
    const callerInput = await this.loadStatistics(); //statistics
    const statistics = callerInput.map((s) => (s.name));
    const type = 'recordstructure';
    const ttype = 'STATISTIC';
    const objtype = 'RECORD_STRUCTURE';
    try {
      let deleteList = [];
      for (let i = 0; i < statistics.length; i += 1) {
        const elementsData = await this.messageService.postRecordStructureDirectory(
          statistics[i], false, type, ttype, objtype, undefined, undefined,
        );
        if (elementsData.entrys !== undefined) {
          deleteList = deleteList.concat(elementsData.entrys);
        }
      }
      this.setState({
        deleteList,
      });
    } catch {
      // no error log
    } finally {
      this.setState({
        visible: false,
      });
    }
  }

  async loadStatistics(returnMessage) {
    const statisticsList = await this.messageService.postStatisticDirectory(returnMessage);
    return statisticsList;
  }

  returnMap(tmpStatisticsList, obj) {
    let doc = null;
    const ret = [];
    for (let i = 0; i < tmpStatisticsList.length; i += 1) {
      const entry = tmpStatisticsList[i];
      doc = {
        docType: obj,
        _id: `${obj}ID${entry.id}`,
        text: this.multiLanguage.returnInLanguage(entry, 'de'),
        name: entry.name,
        id: entry.id,
        valueCount: entry.valueCount,
        classificationKey: entry.classificationKey,
      };
      this.db.put(doc); //save in browser's pouchDb
      ret.push(doc);
    }
    return ret;
  }

  async loadStatisticList(objtype, type, obj, directionInput, entrys, maxRowsPerPage) {
    let direction = directionInput;
    this.setState({ visible: true });
    let doRepeat = true;
    let statisticsList = [];
    let tmpStatisticsList;
    let lastEntry;
    // loop until all values have been received
    let nodes = [];
    let collect;
    while (doRepeat) {
      tmpStatisticsList = await this.messageService.postRecordStructureDirectory1(
        objtype, type, obj, direction, lastEntry, maxRowsPerPage,
      );
      if (tmpStatisticsList[1] && tmpStatisticsList[1] === 'error') {
        this.growl.show({ severity: tmpStatisticsList[1], summary: 'Hinweis', detail: tmpStatisticsList[0] });
        return;
      }
      if (tmpStatisticsList.length < maxRowsPerPage) {
        statisticsList = tmpStatisticsList;
        doRepeat = false;
        collect = this.returnMap(tmpStatisticsList, obj);
      } else {
        lastEntry = tmpStatisticsList[tmpStatisticsList.length - 1];
        // entrys = lastEntry;
        direction = 'FORWARD';
        if (lastEntry === 'error') doRepeat = false; //error found => exit
        // add lastEntry to entrys of
        statisticsList = statisticsList.concat(tmpStatisticsList);
        collect = this.returnMap(tmpStatisticsList, obj);
      }
      nodes = nodes.concat(collect);
    }
    if (obj === 6) {
      this.setState({ expressionData: nodes }); //Ausprägung
    } else if (obj === 3) {
      this.setState({ characteristicData: nodes }); //Merkmal
    } else {
      this.setState({ dsbData: nodes }); //DSB
    }
    this.setState({ visible: false });
  }

  async viewProperties(line, tabNumber, entryPropertiesInput) {
    const { tabsEntrys } = this.state;
    //Merkmal: id, 3, variable
    let object = 3;
    let link = 'variable';
    if (tabNumber === 2) {
      //Ausprägung: id, 6, value
      object = 6;
      link = 'value';
    } else if (tabNumber > 2) {
      //Ausprägung-Zuordnung: id, 112, valueassociation ///
      object = 112;
      link = 'valueassociation';
    } else if (tabNumber === 0) {
      object = 138;
      link = 'recordstructure';
    }
    const elementsData = await this.messageService.postRecordStructureProperties(
      line.id, object, link, true,
    );
    if (elementsData[0]) {
      this.growl.show({ severity: 'success', summary: 'Eigenschaften', detail: `Eigenschaften für ${line.name} (${line.id}) wurden geladen.` });
      if (elementsData[1] && elementsData[1] === 'error') {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      } else {
        const entryProperties = entryPropertiesInput;
        tabsEntrys[tabNumber] = elementsData;
        let coding = '';
        let statisticName = '';
        if (elementsData[0].coding) coding = elementsData[0].coding;
        if (elementsData[0].statisticName) statisticName = elementsData[0].statisticName;
        entryProperties[tabNumber] = {
          name: elementsData[0].name,
          longtext: this.returnLongtext(elementsData[0]),
          shortdescription: this.multiLanguage.returnInLanguage(elementsData[0], 'de'),
          detail2: elementsData[0].id,
          detail3: coding,
          statisticName,
        };
        this.setState({
          entryProperties,
          tabsEntrys,
        });
      }
    } else {
      this.growl.show({ severity: 'info', summary: 'Eigenschaften', detail: `Es konnte keine Eigenschaften für ${line.name} (${line.id}) geladen werden.` });
    }
  }

  async loadRecordStructure(line) {
    const { name } = line;
    const isSecondOption = false;
    const type = 'valueassociation';
    const ttype = 'VARIABLE';
    const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
    const { tabsObject } = this.state;
    const arr = [...tabsObject];
    let hasAlreadyBeenLoaded = false;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].tabId === line.name) hasAlreadyBeenLoaded = true;
    }
    if (hasAlreadyBeenLoaded) {
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: `Die Daten für ${line.name} wurden bereits geladen.` });
    } else {
      this.setState({ visible: true });
      let elementsData = await this.messageService.postRecordStructureDirectory(
        name, isSecondOption, type, ttype, objtype,
      );
      const smallData = [];
      for (let i = 0; i < elementsData.length; i += 1) {
        const d = elementsData[i];
        const item = {
          name: d.name,
          longtext: d.longtext,
          shortDescription: d.shortDescription,
          id: d.id,
        };
        smallData.push(item);
      }
      this.setState({ visible: false });
      if (elementsData[0]) {
        this.growl.show({ severity: 'info', summary: 'Ausprägungen', detail: `Ausprägungen zu ${line.name} (${line.id}) wurden geladen.` });
        if (elementsData[1] && elementsData[1] === 'error') {
          this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
        } else {
          elementsData = smallData;
          const ret = this.returnTabData(elementsData, line);
          const tmp = [...tabsObject];
          tmp[tmp.length] = ret;
          this.setState({ tabsObject: tmp });
        }
      }
    }
  }

  returnTabData(elementsData, source) { //retruns the data as an object for one tab
    const tab = { //object tab
      tabName: '',
      tabId: '',
      tabHeader: '',
      tabTable: [],
      tabNumber: 0,
    };
    const { tabsObject, shortLanguage } = this.state;
    tab.tabNumber = tabsObject.length;
    tab.tabId = source.name;
    tab.tabName = `Ausprägungen zu ${source.name}`;
    tab.tabHeader = `Ausprägungen zu ${source.name} ${source.text}`;
    let entry = null;
    const retArray = [];
    for (let i = 0; i < elementsData.length; i += 1) {
      entry = elementsData[i];
      let langText;
      if (entry.shortDescription) {
        langText = this.multiLanguage.returnLanguage(entry.shortDescription, shortLanguage);
      }
      retArray[i] = {
        _id: `ID${entry.id}`, //will be timestamp?
        name: entry.name,
        id: entry.id,
        langText,
      };
    }
    tab.tabTable = retArray;
    return tab;
  }

  remainingTabpanels(entryProperties, tabsObject) {
    const header = (
      <div style={{ textAlign: 'left' }}>
        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
        <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Suche über alle Werte" size="50" />
      </div>
    );
    const { globalFilter } = this.state;
    let elementsData = [];
    let name = '';
    let shortdescription = '';
    let longtext = '';
    let hide = true;
    if (tabsObject) {
      elementsData = tabsObject;
      if (elementsData.length > 0) {
        return (
          elementsData.map((entry, i) => {
            entryProperties.length > i + 3 ? name = entryProperties[i + 3].name : name = '';
            entryProperties.length > i + 3 ? shortdescription = entryProperties[i + 3].shortdescription : shortdescription = '';
            entryProperties.length > i + 3 ? longtext = entryProperties[i + 3].longtext : longtext = '';
            entryProperties.length > i + 3 ? hide = (!entryProperties[i + 3].name) : hide = true;
            return (
              <TabPanel key={i} header={entry.tabName}>
                <div className="p-grid dashboard">
                  <div className="p-col-8">
                    <div style={{ width: '100%' }}>
                      <Button
                        id="close"
                        className="p-button-secondary"
                        tooltip="Reiter schließen"
                        onClick={() => this.closeTab(entry.tabNumber)}
                        type="button"
                        style={{ float: 'right', margin: '4px 4px 0 0' }}
                        icon="pi pi-md-clear"
                      />
                    </div>
                    <Card
                      title={entry.tabHeader}
                      style={{ height: '100%' }}
                    >
                      <DataTable
                        stateKey={`tablestate-tab${entry.tabName}`}
                        globalFilter={globalFilter}
                        header={header}
                        ref={(el) => { this.dt = el; }}
                        value={entry.tabTable}
                        paginator
                        paginatorPosition="both"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="({currentPage} von {totalPages})"
                        rows={30}
                        rowsPerPageOptions={[5, 10, 20, 30, 100]}
                      >
                        <Column filter={false} style={{ width: '8em' }} field="name" header="Name" sortable />
                        <Column filter={false} style={{ width: '15em' }} field="langText" header="Beschreibung" sortable />
                        <Column header="Aktionen" body={(ex) => this.actionTemplate(i + 3, ex, entryProperties)} style={{ textAlign: 'center', width: '6em' }} />
                      </DataTable>
                    </Card>
                  </div>
                  <div className="p-col-4">
                    <Card
                      style={{ height: '100%' }}
                      title="Eigenschaften"
                    >
                      <div>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: 'top' }}>Name:</td>
                              <td style={{ wordBreak: 'break-all' }}>{name}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: 'top' }}>Beschreibung:</td>
                              <td style={{ wordBreak: 'break-all' }}>{shortdescription}</td>
                            </tr>
                            <tr>
                              <td style={{ verticalAlign: 'top' }}>Langtext:</td>
                              <td style={{ wordBreak: 'break-all' }}>{longtext}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p />
                      <Button
                        id={`edit${i}${3}`}
                        disabled={hide}
                        label="Bearbeiten"
                        onClick={() => this.showEdit(
                          entryProperties[i + 3].name,
                          entryProperties[i + 3].shortdescription,
                          entryProperties[i + 3].longtext,
                          i + 3,
                        )}
                        type="button"
                        icon="pi pi-md-playlist-add"
                        className="p-button-success"
                        style={{ marginRight: '.5em' }}
                      />
                    </Card>
                  </div>
                </div>
              </TabPanel>
            );
          })
        );
      }
      return (<span />);
    }
    return (<span />);
  }

  closeTab(n) {
    const { tabsObject } = this.state;
    const arr = [...tabsObject];
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].tabNumber === n) {
        arr.splice(i, 1);
      }
    }
    this.setState({
      tabsObject: arr,
      activeIndexTab: arr.length + 1,
    });
  }

  actionTemplatePages(obj) {
    const tabNumber = 2;
    const { entryProperties } = this.state;
    return (
      <>
        <Button
          id="deleteData"
          tooltip="Eintrag löschen"
          onClick={() => this.handleDelete(obj, tabNumber)}
          type="button"
          icon="pi pi-md-delete-forever"
          className="p-button-danger"
          style={{ marginRight: '.5em' }}
        />
        <Button
          id="loadData4"
          tooltip="Eigenschaften anzeigen"
          onClick={() => this.viewProperties(obj, tabNumber, entryProperties)}
          type="button"
          icon="pi pi-md-web-asset"
          className="p-button-warning"
        />
      </>
    );
  }

  actionTemplate(tabNumber, obj, entryProperties) {
    return (
      <div>
        {tabNumber === 1
          ? (
            <Button
              id="loadData3"
              tooltip={obj.valueCount === 0 || obj.valueCount === null ? 'keine Ausprägungsdaten vorhanden' : 'Ausprägungen laden'}
              onClick={() => this.loadRecordStructure(obj)}
              disabled={obj.valueCount === 0 || obj.valueCount === null}
              type="button"
              icon="pi pi-md-playlist-add"
              className="p-button-success"
              style={{ marginRight: '.5em' }}
            />
          )
          : ''}
        {tabNumber === 0
          ? (
            <Button
              id="deleteData"
              tooltip="Eintrag löschen"
              onClick={() => this.handleDelete(obj, tabNumber)}
              type="button"
              icon="pi pi-md-delete-forever"
              className="p-button-danger"
              style={{ marginRight: '.5em' }}
            />
          )
          : ''
        }
        {tabNumber > 0
          ? (
            <Button
              id="deleteData"
              tooltip="Eintrag löschen"
              onClick={() => this.handleDelete(obj, tabNumber)}
              type="button"
              icon="pi pi-md-delete-forever"
              className="p-button-danger"
              style={{ marginRight: '.5em' }}
            />
          )
          : ''
        }
        <Button
          id="loadData4"
          tooltip="Eigenschaften anzeigen"
          onClick={() => this.viewProperties(obj, tabNumber, entryProperties)}
          type="button"
          icon="pi pi-md-web-asset"
          className="p-button-warning"
        />
      </div>
    );
  }

  showEdit(valueName, valueDescription, valueLongtext, editTabNumber) {
    this.setState({
      valueName,
      valueDescription,
      valueLongtext,
      editTabNumber,
      editVisible: true,
    });
  }

  async refreshData() {
    this.db.destroy().then(() => { // purge puchDb
      window.location.replace('./referencedata');
    }).catch((err) => {
      // error occurred
      // eslint-disable-next-line no-console
      console.log('destroy: error', err);
    });
  }

  renderFooter() {
    return (
      <div>
        <Button id="save" label="Speichern" className="p-button-danger" icon="pi pi-check" onClick={() => this.handleSave()} />
        <Button id="cancel" label="Abbrechen" className="p-button-primary" icon="pi pi-times" onClick={() => this.setState({ editVisible: false })} />
      </div>
    );
  }

  renderFooterDelete(name) {
    const del = (
      <div>
        <Button id="yes" label="Ja" icon="pi pi-check" onClick={() => this.handleYes()} />
        <Button id="no" label="Nein" className="p-button-danger" icon="pi pi-times" onClick={() => this.onHide('visibleDelete')} />
      </div>
    );
    const deleteAgain = (
      <div>
        <Button id="yes" label="Ja" icon="pi pi-check" onClick={() => this.handleYesAgain()} />
        <Button id="no" label="Nein" className="p-button-danger" icon="pi pi-times" onClick={() => this.onHide('visibleDeleteAgain')} />
      </div>
    );
    if (name === 'displayDelete') {
      return del;
    }
    return deleteAgain;
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      const { refValues } = this.state.tableData;
      return this.onPage(refValues, 'refValues');
      // return this.loadDataPage(null, 'TOP', null, rowsPerPage);
    }
    return Promise.resolve();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  clearSearch() {
    this.setState({ searchText: '', searchCriterion: { name: 'Name', value: 'Fachschlüssel' } }, () => {
      // this.loadDataPage(null, 'TOP', null, rowsPerPage);
    });
  }

  makeHeaderCell(criterionName, text, sortable) {
    const { sortingSelection, sortCriterion } = this.state;
    const lookup = sortingSelection[criterionName];
    let retColor;
    let retClass;
    if (criterionName !== sortCriterion) {
      retClass = 'p-sortable-column-icon pi pi-fw pi-sort';
      retColor = 'grey';
    } else {
      retColor = 'black';
      if (lookup === 'ASC') {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-up';
      } else {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-down';
      }
    }
    const sortingClass = retClass;
    let ret = (
      <th style={{ cursor: 'pointer', color: retColor }} onClick={() => this.selectSorting(criterionName)}>
        {text}
        <span className={sortingClass} />
      </th>
    );
    if (!sortable) {
      ret = (
        <th style={{ color: retColor }}>
          {text}
          <span />
        </th>
      );
    }
    return ret;
  }

  // shows a Message at the top of the table
  showMessage(messageDetail, messageSeverity) {
    const msg = {
      life: 5000,
      severity: messageSeverity,
      detail: messageDetail,
    };
    this.messages.show(msg);
  }

  selectSorting(newSortCriterion, reset) {
    const { sortCriterion, sortDirection, sortingSelection } = this.state;
    let newSortDirection;
    if (!reset) {
      // set selection states:
      if (sortCriterion === newSortCriterion) {
        // search criterion remains unchanged -> change sort direction
        newSortDirection = sortDirection === 'DESC' ? 'ASC' : 'DESC';
      } else {
        // other search criterion -> change sort direction to ascending
        newSortDirection = 'DESC';
      }
    }
    sortingSelection[newSortCriterion] = newSortDirection;
    this.setState({ sortDirection: newSortDirection });
    this.setState({ sortCriterion: newSortCriterion });
    // this.setState({ sortingSelection }, () => this.loadDataPage(null, 'TOP', null, rowsPerPage));
  }

  async loadDataPage() {
    this.setState({ visible: true });
    const { refValues } = this.state.tableData;
    this.onPage(refValues, 'refValues');
    this.setState({ visible: false });
  }

  onSelectChange = (e) => {
    this.setState({ searchCriterion: e.value });
  }

  showUserList(entryList) {
    const userRights = returnUserRights();
    // const cannotDelete = !hasPermission(userRights, actions.UserDelete);
    // const cannotEdit = !hasPermission(userRights, actions.UserEditInfo);
    const tabNumber = 2;
    let ret = (<div />);

    if (entryList) {
      const { entryProperties } = this.state;
      let r1 = [];
      for (let i = 0; i < entryList.length; i += 1) {
        const s = entryList[i];
        const entry = entryList[i];
        const obj = 6;
        const doc = {
          docType: obj,
          _id: `${obj}ID${entry.id}`,
          text: this.multiLanguage.returnInLanguage(entry, 'de'),
          name: entry.name,
          id: entry.id,
          valueCount: entry.valueCount,
          classificationKey: entry.classificationKey,
        };
        const line = (
          <tr key={s.name}>
            <td>{s.name}</td>
            <td>{this.multiLanguage.returnInLanguage(s, 'de')}</td>
            <td>{s.classificationKey}</td>
            <td>
              <Button
                id="deleteData"
                tooltip="Eintrag löschen"
                onClick={() => this.handleDelete(doc, tabNumber)}
                type="button"
                icon="pi pi-md-delete-forever"
                className="p-button-danger"
                style={{ marginRight: '.5em' }}
              />
              <Button
                id="loadData4"
                tooltip="Eigenschaften anzeigen"
                onClick={() => this.viewProperties(doc, tabNumber, entryProperties)}
                type="button"
                icon="pi pi-md-web-asset"
                className="p-button-warning"
              />
            </td>
          </tr>
        );
        r1.push(line);
      }
      ret = r1;
    }
    return ret;
  }

  render() {
    const role = sessionStorage.getItem('role');
    const group = sessionStorage.getItem('group');
    const isAdmin = role === 'GROUP_ADMIN';
    const isSysAdmin = role === 'SYSTEM_ADMIN';
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    const isStBA = group === 'StBA';
    if (!(isSysAdmin || isSuperAdmin || (isAdmin && isStBA))) {
      window.location.replace('./');
      return;
    }
    const header0 = (
      <div style={{ textAlign: 'left' }}>
        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
        <InputText type="search" onInput={(e) => this.setState({ globalFilter0: e.target.value })} placeholder="Suche über alle Werte" size="50" />
      </div>
    );
    const header1 = (
      <div style={{ textAlign: 'left' }}>
        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
        <InputText type="search" onInput={(e) => this.setState({ globalFilter1: e.target.value })} placeholder="Suche über alle Werte" size="50" />
      </div>
    );

    const {
      dsbData,
      characteristicData,
      expressionData,
      loading,
      entryProperties,
      tabsObject,
      visible,
      visibleDelete,
      visibleDeleteAgain,
      editVisible,
      valueName,
      valueDescription,
      activeIndexTab,
      globalFilter0,
      globalFilter1,
      globalFilter2,
    } = this.state;
    const paginatorLeft = (
      <Button
        type="button"
        tooltip="Hilfe"
        id="info"
        onClick={(e) => this.op.toggle(e)}
        icon="pi pi-md-info-outline"
      />
    );
    const paginatorRight = (
      <div>
        <Button
          type="button"
          tooltip="Cache löschen und Daten neu laden"
          id="refresh"
          onClick={() => this.refreshData()}
          icon="pi pi-md-refresh"
        />
      </div>
    );
    // const rowsPerPage = 30;
    // const userRights = returnUserRights();
    // const cannotCreate = !hasPermission(userRights, actions.UserCreate);
    const {
      deleteDialogVisible, pageData, searchCriterion, searchText,
    } = this.state;
    const tableData = this.state.tableData.refValues.data;

    const refValues = this.state.tableData.refValues;
    const jobsRows = refValues.rows ? parseInt(refValues.rows, 10) : 10;
    const jobsTotalRecords = refValues.totalRecords;
    const jobsFirst = refValues.first;
    const jobsLast = refValues.last;
    const jobsPageTemplate = `${jobsFirst + 1} bis ${jobsLast + 1} von ${jobsTotalRecords} Einträgen`;
    const jobsData = refValues.data;

    return (
      <div>
        <Messages
          ref={(el) => { this.messages = el; }}
          style={{ marginBottom: '1em' }}
        />
        <OverlayPanel ref={(el) => { this.op = el; }} showCloseIcon dismissable>
          <h3>Hilfe zum Referenzmetadatenbereich</h3>
          <p>
            Sie befinden sich als Fachadministrator im Referenzmetadatenbereich,
            der einer statistikunabhängigen Darstellung sowie der
            <br />
            Bearbeitung, aller im System hinterlegten Merkmale und Merkmalsausprägungen dient.
            Der eigentliche Metadatenbereich stellt
            {' '}
            <br />
            allen Nutzern eine Übersicht über die statistikspezifischen Merkmale und
            deren Merkmalsausprägungen bereit. Nur der
            {' '}
            <br />
            Fachadministrator des Statistischen Bundesamts kann dort komplette
            Datensatzbeschreibungen editieren und löschen. Ein Löschen
            {' '}
            <br />
            einzelner Schlüssel oder Merkmale ist aufgrund der Abhängigkeiten
            zwischen den Metadatenkomponenten nicht möglich.
          </p>

          <p>
            Einzelne Merkmale und deren zugeordnete Ausprägungen können hier
            im Referenzmetadatenbereich editiert oder gelöscht werden.
            <br />
            Es ist zu beachten, dass eine Änderung oder Löschung Auswirkungen
            auf alle verknüpften Metadatenkomponenten hat. Wird
            {' '}
            <br />
            eine verknüpfte Ausprägung verändert, wirkt sich dies auf alle zugeordneten
            Merkmale aus, während eine Änderung des Merkmals
            {' '}
            <br />
            über das zugeordnete Datenfeld Auswirkungen auf die Datensatzbeschreibung hat.
          </p>

          <p>
            Über das Register „Merkmale“ können dazu die Merkmale eingesehen und
            deren zugeordnete Ausprägungen geladen werden.
            <br />
            Im Register „Ausprägungen“ sämtliche Merkmalsausprägungen unabhängig
            von ihren Merkmalen aufgeführt. Eine
            {' '}
            <br />
            Bearbeitung kann insbesondere sinnvoll oder notwendig sein, wenn alte
            Merkmalsausprägungen oder Merkmale nicht mehr benötigt
            {' '}
            <br />
            werden oder auch fehlerhaft importiert wurden und aus dem System entfernt
            werden müssen.
          </p>
        </OverlayPanel>
        <Dialog
          header="Lade Daten..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <ProgressSpinner />
        </Dialog>

        <Dialog
          header="Eintrag löschen"
          visible={visibleDelete}
          style={{ width: '40vw' }}
          footer={this.renderFooterDelete('displayDelete')}
          onHide={() => this.onHide('visibleDelete')}
          modal
        >
          <p>
            Wollen Sie den Eintrag und alle davon
            abhängigen Daten wirklich löschen?
          </p>
        </Dialog>

        <Dialog
          header="Löschen"
          visible={visibleDeleteAgain}
          style={{ width: '40vw' }}
          footer={this.renderFooterDelete('displayDeleteAgain')}
          onHide={() => this.onHide('visibleDeleteAgain')}
          modal
        >
          <p>
            Zu diesem Element existieren abhängige Daten.
            Wollen Sie wirklich löschen?
          </p>
        </Dialog>

        <Dialog
          header="Daten bearbeiten"
          footer={this.renderFooter()}
          style={{ width: '60vw' }}
          closeOnEscape={false}
          visible={editVisible}
          modal
          onHide={() => this.setState({ editVisible: false })}
        >
          <Card>
            <div className="p-grid p-fluid">
              <div className="p-col-12 pi-md-12">
                <p />
                <p />
                <span className="md-inputfield">
                  <InputText disabled id="in" value={valueName || ''} onChange={(e) => this.setState({ valueName: e.target.value })} />
                  <label htmlFor="in">Name</label>
                </span>
                <p />
                <p />
              </div>

              <div className="p-col-12 pi-md-12">
                <span className="md-inputfield">
                  <InputText id="in" value={valueDescription || ''} onChange={(e) => this.setState({ valueDescription: e.target.value })} />
                  <label htmlFor="in">Beschreibung</label>
                </span>
                <p />
                <p />
              </div>
            </div>
          </Card>
        </Dialog>

        <Growl style={{ position: 'absolute', left: '78.5%', top: '345px' }} ref={(el) => { this.growl = el; }} />
        <Card style={{ height: '100%' }}>
          <TabView id="referenceDataTab" activeIndex={activeIndexTab} onTabChange={(e) => this.setState({ activeIndexTab: e.index })}>
            <TabPanel header="DSB">
              <div className="p-grid dashboard">
                <div className="p-col-8">
                  <Card style={{ height: '100%' }}>
                    <DataTable
                      autoLayout
                      stateKey="tablestate-tab0"
                      globalFilter={globalFilter0}
                      header={header0}
                      ref={(el) => { this.dt = el; }}
                      value={dsbData}
                      paginator
                      paginatorPosition="both"
                      paginatorLeft={paginatorLeft}
                      paginatorRight={paginatorRight}
                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                      currentPageReportTemplate="({currentPage} von {totalPages})"
                      rows={30}
                      rowsPerPageOptions={[5, 10, 20, 30, 100]}
                    >
                      <Column filter={false} style={{ width: '4em' }} field="name" header="Kurzname" sortable />
                      <Column filter={false} style={{ width: '20em' }} field="text" header="Name der Datensatzbeschreibung" sortable />
                      <Column header="Aktionen" body={(ex) => this.actionTemplate(0, ex, entryProperties)} style={{ textAlign: 'center', width: '6em' }} />
                    </DataTable>
                  </Card>
                </div>
                <div className="p-col-4">
                  <Card
                    style={{ height: '100%' }}
                    title="Eigenschaften"
                  >
                    <div>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Kurzname:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[0].name}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Name der Datensatzbeschreibung:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[0].shortdescription}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>EVAS-Nr.:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[0].statisticName}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p />
                    <Button
                      id="edit0"
                      disabled={!entryProperties[0].name}
                      label="Bearbeiten"
                      onClick={() => this.showEdit(
                        entryProperties[0].name,
                        entryProperties[0].shortdescription,
                        entryProperties[0].longtext,
                        0,
                      )}
                      type="button"
                      icon="pi pi-md-playlist-add"
                      className="p-button-success"
                      style={{ marginRight: '.5em' }}
                    />
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Merkmale">
              <div className="p-grid dashboard">
                <div className="p-col-8">
                  <Card style={{ height: '100%' }}>
                    <DataTable
                      autoLayout
                      stateKey="tablestate-tabA"
                      globalFilter={globalFilter1}
                      header={header1}
                      ref={(el) => { this.dt = el; }}
                      value={characteristicData}
                      paginator
                      paginatorPosition="both"
                      paginatorLeft={paginatorLeft}
                      paginatorRight={paginatorRight}
                      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                      currentPageReportTemplate="({currentPage} von {totalPages})"
                      rows={30}
                      rowsPerPageOptions={[5, 10, 20, 30, 100]}
                    >
                      <Column filter={false} style={{ width: '4em' }} field="name" header="Name" sortable />
                      <Column filter={false} style={{ width: '20em' }} field="text" header="Beschreibung" sortable />
                      <Column filter={false} style={{ width: '6em' }} field="valueCount" header="Anzahl Ausprägungen" sortable />
                      <Column header="Aktionen" body={(ex) => this.actionTemplate(1, ex, entryProperties)} style={{ textAlign: 'center', width: '8em' }} />
                    </DataTable>
                  </Card>
                </div>

                <div className="p-col-4">
                  <Card
                    style={{ height: '100%' }}
                    title="Eigenschaften"
                  >
                    <div>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Name:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[1].name}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Beschreibung:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[1].shortdescription}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Langtext:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[1].longtext}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p />
                    <Button
                      id="edit0"
                      disabled={!entryProperties[1].name}
                      label="Bearbeiten"
                      onClick={() => this.showEdit(
                        entryProperties[1].name,
                        entryProperties[1].shortdescription,
                        entryProperties[1].longtext,
                        1,
                      )}
                      type="button"
                      icon="pi pi-md-playlist-add"
                      className="p-button-success"
                      style={{ marginRight: '.5em' }}
                    />
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Ausprägungen">
              <div className="p-grid dashboard">
                <div className="p-col-8">
                  <Card>
                    <div className="p-grid">
                      <div className="p-col-4">
                        <DropdownLabeled
                          label="Selektionskriterium"
                          customClass="p-col-2"
                          id="criterion"
                          value={searchCriterion}
                          options={selectionList}
                          onChange={this.onSelectChange}
                          optionLabel="name"
                        />
                      </div>
                      <div className="p-col-8">
                        <span style={{
                          fontSize: '23px',
                        }}
                        >
                          &nbsp;
                        </span>
                        <span className="p-float-label">
                          <InputText id="search-input" type="text" size="33" value={searchText} onKeyDown={(e) => this.handleKeyDown(e)} onChange={(e) => this.setState({ searchText: e.target.value })} />
                          <label htmlFor="search-input">Suchtext</label>
                        </span>
                      </div>
                      <div className="p-col-12">
                        <DataTable
                          autoLayout
                          stateKey="tablestate-tab2"
                          selectionMode="single"
                          value={jobsData}
                          paginator
                          paginatorPosition="both"
                          paginatorTemplate="FirstPageLink PrevPageLink NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                          rows={jobsRows}
                          rowsPerPageOptions={[5, 10, 20, 30, 100]}
                          currentPageReportTemplate={jobsPageTemplate}
                          totalRecords={jobsTotalRecords}
                          lazy
                          first={jobsFirst}
                          onPage={(e) => this.onPage(e, 'refValues')}
                          loading={loading}
                          resizableColumns
                        >
                          <Column field="name" header="Name" style={{ width: '30%' }} />
                          <Column field="description" header="Beschreibung" style={{ width: '40%' }} />
                          <Column field="classificationKey" header="Kl.schl." style={{ width: '15%' }} />
                          <Column header="Aktionen" body={(obj) => this.actionTemplatePages((obj))} style={{ textAlign: 'center', width: '2em' }} />
                        </DataTable>
                      </div>
                    </div>
                  </Card>
                </div>

                <div className="p-col-4">
                  <Card
                    style={{ height: '100%' }}
                    title="Eigenschaften"
                  >
                    <div>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Name:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[2].name}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Beschreibung:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[2].shortdescription}</td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: 'top' }}>Langtext:</td>
                            <td style={{ wordBreak: 'break-all' }}>{entryProperties[2].longtext}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p />
                    <Button
                      id="edit1"
                      disabled={!entryProperties[2].name}
                      label="Bearbeiten"
                      onClick={() => this.showEdit(
                        entryProperties[2].name,
                        entryProperties[2].shortdescription,
                        entryProperties[2].longtext,
                        2,
                      )}
                      type="button"
                      icon="pi pi-md-playlist-add"
                      className="p-button-success"
                      style={{ marginRight: '.5em' }}
                    />
                  </Card>
                </div>
              </div>

            </TabPanel>
            {this.remainingTabpanels(entryProperties, tabsObject)}
          </TabView>
        </Card>
      </div>
    );
  }
}
